// extracted by mini-css-extract-plugin
export default {"links":"mainPage_links__g-oAT","link":"mainPage_link__1i9vr","zoomed":"mainPage_zoomed__w8+DN","linkBlurry":"mainPage_linkBlurry__FNyWY","soon":"mainPage_soon__EVD+C"};